const MuiCardHeader = {
    styleOverrides: {
        root: {
            padding: '16px 24px',
        },
    },
};

export { MuiCardHeader };
